// DC Campus landing — Western/Fanshawe drop-off toggle.
// All copy/colors come from data-* attributes rendered by Liquid (section settings),
// so this stays generic instead of hardcoding school names or copy.
(function () {
  var root = document.querySelector('.dc-cmp-root');
  if (!root) return;

  var buttons = root.querySelectorAll('[data-cmp-school-btn]');
  var spiritDot = root.querySelector('[data-cmp-spirit-dot]');
  var spiritGlow = root.querySelector('[data-cmp-spirit-glow]');
  var dropoffRule = root.querySelector('[data-cmp-dropoff-rule]');

  function applySchool(btn) {
    var school = btn.getAttribute('data-cmp-school-btn');
    var accent = btn.getAttribute('data-accent') || '#D4A84F';
    var accentRgb = btn.getAttribute('data-accent-rgb') || '212,168,79';

    buttons.forEach(function (b) {
      var active = b === btn;
      b.classList.toggle('is-active', active);
      b.style.background = active ? b.getAttribute('data-accent') : 'transparent';
      b.style.borderColor = active ? b.getAttribute('data-accent') : '';
    });

    root.querySelectorAll('[data-cmp-for-school]').forEach(function (el) {
      el.hidden = el.getAttribute('data-cmp-for-school') !== school;
    });

    if (spiritDot) spiritDot.style.background = accent;
    if (spiritDot) spiritDot.style.boxShadow = '0 0 0 3px rgba(' + accentRgb + ',0.22)';
    if (spiritGlow) spiritGlow.style.background =
      'radial-gradient(70% 120% at 8% 50%, rgba(' + accentRgb + ',0.20) 0%, transparent 62%)';
    if (dropoffRule) dropoffRule.style.background =
      'linear-gradient(90deg,' + accent + ' 0%,rgba(' + accentRgb + ',0.25) 55%,transparent 100%)';
  }

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () { applySchool(btn); });
  });

  var initial = root.querySelector('[data-cmp-school-btn].is-active') || buttons[0];
  if (initial) applySchool(initial);
})();
